import { NavigationSubItem } from "../navigation-item"

export class TreasuryMoreSubItem extends NavigationSubItem {
  readonly id = "treasury"
  readonly label = "Treasury"
  readonly href = "/treasury"
  readonly iconName = "dollar-icon"
  readonly isExternal = false
  readonly tabs = []
}
